import React, { useState, useEffect, useCallback } from 'react'
import InvadersList from './InvadersList'
import ScrollToTop from '../../UI/ScrollToTop'
import Header from '../Header'
import { StyledEngineProvider } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { increment } from './counterSlice'
import classes from './Creation.module.css'

const Creation = () => {
  const dispatch = useDispatch()

  const [name, setName] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const urlDB =
    'https://invadersreact-default-rtdb.europe-west1.firebasedatabase.app/invaders.json'

  const fetchInvadersHandler = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await fetch(urlDB)
      if (!response.ok) {
        throw new Error('Something went wrong!')
      }

      const data = await response.json()

      const loadedInvaders = []

      for (const key in data) {
        loadedInvaders.push({
          id: key,
          name: data[key].name,
          shape: data[key].shape,
          color: data[key].color,
          colorSet: data[key].colorSet,
          date: data[key].date,
        })
      }

      setName(loadedInvaders)
    } catch (error) {
      console.log(error)
      setError(error.message)
    }
    setIsLoading(false)
  }, [])

  const [caughtError, setCaughtError] = useState('')
  const handleCaughtError = (x) => {
    setCaughtError(x)
  }

  async function addInvaderHandler(invader) {
    try {
      const response = await fetch(urlDB, {
        method: 'POST',
        body: JSON.stringify(invader),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const data = await response.json()
      console.log(data)
      handleCaughtError('')
      fetchInvadersHandler()
    } catch (errore) {
      console.log(errore)
      setError(errore.message)
      handleCaughtError('Something went wrong!')
    }
  }

  let content = <p>Found no invaders.</p>
  if (name.length > 0) {
    content = <InvadersList name={name} />
  }

  if (isLoading) {
    content = <p>Loading...</p>
  }

  useEffect(() => {
    fetchInvadersHandler()
    dispatch(increment(name.length))
  }, [fetchInvadersHandler, dispatch, name.length])

  return (
    <ScrollToTop>
      <div>
        <StyledEngineProvider injectFirst>
          <Header />
          <Outlet
            context={{
              onAddInvader: addInvaderHandler,
              caughtError: caughtError,
              name: name,
            }}
          />

          <div className={classes.container}>
            <div className={classes.midContainer}>
              <section>{content}</section>
            </div>
          </div>
        </StyledEngineProvider>
      </div>
    </ScrollToTop>
  )
}

export default Creation
